module.exports = __webpack_public_path__ + "static/media/06-valmir-pontes.db2f78ce.webp";